/* eslint react/jsx-handler-names:0 */
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  reduxForm,
  propTypes,
  formValueSelector,
  change
} from 'redux-form';
import Dialog from 'react-bootstrap-dialog';
import { eventdefaults, forms } from '../../utils/constants';
import { checkRole, isEmpty } from '../../utils/functions';
import userManager from '../../userManager';
import { getRequest } from '../../utils/functions/httpRequest';
import { URL } from '../../config';
import ContentWrapper from "../../components/layout/ContentWrapper";
import Wizard from '../../components/common/wizard';
import {
  fetchActiveSeasons,
  deleteEvent,
  copyEvent,
  resetEventWizard,
  resetEventState,
  fetchEvent,
  setDefaultEventSeason,
  fetchingEvents,
  fetchEvents
} from "../../redux/actions/action_event";
import { setUserRole } from "../../redux/actions/action_user";
import '../../utils/css/nospinner.css';
import { StepActions } from '../../components/common/wizard/logic';
import SearchBar from './components/searchbar';
import Stats from './components/stats';
import SearchResults from './components/searchresults';
import {
  goToStep,
  getSteps,
  getWizardComponent
} from "./logic";

const formName = forms.eventinfo

class Event extends Component {

  static propTypes = {
    ...propTypes
  }
  constructor(props) {
    super(props);
    this.state = {
      showSearchResultsMode: false,
      setupNotCompleted: 0,
      pendingApproval: 0,
      upcomingEvents: 0,
      completedCurrentSeason: 0,
      pendingPostEventReport: 0,
      statusSearchValue: '',
      wizardsteps: null,
      component: null,
      saveComponentState: false,
      wizardMode: false,
      stepsSet: false,
    };

    this.refreshEventWizard = this.refreshEventWizard.bind(this);
    this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
    this.getEventStats = this.getEventStats.bind(this);
    this.applyPermission = this.applyPermission.bind(this);
    this.handleAddEvent = this.handleAddEvent.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handlePreviousStep = this.handlePreviousStep.bind(this);
    this.handleGoToStep = this.handleGoToStep.bind(this);
    this.handleOnComponentStateSaved = this.handleOnComponentStateSaved.bind(this);
    this.setWizardSteps = this.setWizardSteps.bind(this);
    this.clearWizardMode = this.clearWizardMode.bind(this);
    this.handleSearchEventsByStatus = this.handleSearchEventsByStatus.bind(this);
    this.handleSearchByChange = this.handleSearchByChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    const { oidc } = this.props;
    const _this = this;
    const { fetchActiveSeasons } = this.props;

    if (oidc.user == null) {
      userManager.signinRedirect().then(function () {
        _this.applyPermission();
      });
    }
    else {
      fetchActiveSeasons().then(function () {
        _this.getEventStats();
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.location.key !== this.props.location.key) {
      this.setState(
        {
          showSearchResultsMode: false,
        });
      this.props.dispatch(resetEventWizard());
      this.props.dispatch(setDefaultEventSeason());
      this.getEventStats();
    }
  }

  componentDidUpdate(nextProps) {
    const {
      copiedEventId,
      dispatch,
    } = this.props;

    if (copiedEventId != undefined && copiedEventId > 0) {
      this.handleViewEventDetails(copiedEventId);
      dispatch(change(formName, 'copiedEventId', -1));
    }

    if (nextProps.seasonId !== this.props.seasonId) {
      this.getEventStats();
    }
  }

  getEventStats() {
    const { seasonId } = this.props;
    const statsendpoint = `/stats/${seasonId}`;
    const eventURL = `${URL.event}${statsendpoint}`;
    const token = this.props.oidc.user.access_token;
    const _this = this;

    getRequest(eventURL, 'json', token).then(function (response) {
      const {
        setupNotCompleted,
        pendingApproval,
        upcomingEvents,
        pendingPostEventReport,
        completedCurrentSeason,
        overallCurrentSeason,
      } = response.data;
      _this.setState({
        setupNotCompleted,
        pendingApproval,
        upcomingEvents,
        pendingPostEventReport,
        completedCurrentSeason,
        overallCurrentSeason,
      });
    });
  }

  refreshEventWizard(updatedSteps) {
    const { steps, next } = updatedSteps;
    const component = getWizardComponent(next);
    this.setState({
      wizardsteps: steps,
      component,
    });
  }

  handleAddEvent = () => {
    const { wizardsteps } = getSteps();
    this.props.dispatch(resetEventWizard());
    this.props.dispatch(setDefaultEventSeason());
    this.props.dispatch(resetEventState());
    const component = getWizardComponent(1);
    this.setState({
      wizardMode: true,
      showSearchResultsMode: false,
      wizardsteps,
      component,
    });
    this.props.history.push('/event');
  }

  handleNextStep() {
    this.setState({ saveComponentState: true });
  }

  handlePreviousStep() {
    const { wizardsteps } = this.state;
    const updatedSteps = goToStep(StepActions.Previous, wizardsteps);
    this.refreshEventWizard(updatedSteps);
  }

  handleGoToStep(step) {
    const { wizardsteps } = this.state;
    const updatedSteps = goToStep(StepActions.GoTo, wizardsteps, step);
    this.refreshEventWizard(updatedSteps);
  }

  handleOnComponentStateSaved(saved) {
    if (saved === true) {
      const { wizardsteps } = this.state;
      const updatedSteps = goToStep(StepActions.Next, wizardsteps);
      this.refreshEventWizard(updatedSteps);
    }
    this.setState({ saveComponentState: false })
  }

  handleViewEventDetails(eventId) {
    this.props.dispatch(fetchEvent(eventId));
    this.props.history.push('/event');
    this.setState({
      showSearchResultsMode: false,
    });
  }

  handleSearchEventsByStatus(status) {
    const { seasonId, dispatch } = this.props;

    dispatch(fetchingEvents());
    dispatch(fetchEvents(seasonId, 'status', status));

    this.setState({
      showSearchResultsMode: true
    })
  }

  handleSearchByChange() {
    this.setState({
      showSearchResultsMode: false
    });
  }

  applyPermission() {
    const { user } = this.props.oidc;
    const { roleChecked } = this.props.user;
    const { dispatch } = this.props;

    if ((user !== null) && (roleChecked === false)) {
      const token = user.access_token;
      checkRole(token).then(function (response) {
        const roleName = response.data.roleName;
        dispatch(setUserRole(roleName));
      })
    }
  }

  setWizardSteps() {
    const { stepsSet } = this.state;
    const {
      currentWizardStep,
      lastStepCompleted,
    } = this.props;

    if (!stepsSet) {
      const { wizardsteps } = getSteps(currentWizardStep, lastStepCompleted);

      const component = getWizardComponent(currentWizardStep);

      this.setState({
        wizardMode: true,
        showSearchResultsMode: false,
        wizardsteps,
        component,
        stepsSet: true,
      })
    }
  }

  clearWizardMode() {
    this.setState({
      wizardMode: false,
      showSearchResultsMode: false,
      stepsSet: false,
      wizardsteps: null,
    });
  }

  handleSearch() {
    this.setState({
      showSearchResultsMode: true
    })
  }

  render() {
    const {
      oidc,
      eventId,
      eventRetrieved
    } = this.props;

    const {
      setupNotCompleted,
      pendingApproval,
      wizardMode,
      showSearchResultsMode,
      wizardsteps,
      component,
      saveComponentState,
      statusSearchValue,
      upcomingEvents,
      pendingPostEventReport,
      completedCurrentSeason
    } = this.state;

    const { searchResults } = this.props;

    const token = isEmpty(oidc.user) === false ? oidc.user.access_token : '';
    const fromSidebar = this.props.location.state !== undefined ? this.props.location.state.fromSidebar : false;
    const showWizard = ((eventId > 0 && eventRetrieved) || (wizardMode)) && (fromSidebar === false);
    const refreshSearch = this.props.refreshSearchResults !== undefined ? this.props.refreshSearchResults : false;

    const showResults = showSearchResultsMode && (searchResults !== undefined);

    if (showWizard) {
      this.setWizardSteps();
    }

    const { roleName } = this.props.user;
    const isAdministrator = roleName === 'Administrator'

    this.applyPermission();

    return (
      <ContentWrapper style={{ minHeight: '1850px' }}>
        <div className="content-heading" style={{ marginBottom: '30px' }}>
          Event Setup
        </div>
        <Dialog ref={(el) => { this.dialog = el }} />
        {
          !wizardMode &&
          (<SearchBar
            token={token}
            isAdministrator={isAdministrator}
            isEventSetup
            handleSearchResults={this.readSearchResults}
            handleAddEvent={this.handleAddEvent}
            executeSearchByStatus={statusSearchValue}
            refreshSearch={refreshSearch}
            SearchByChange={this.handleSearchByChange}
            onSearch={this.handleSearch}
          />)
        }
        {
          !wizardMode && !showResults &&
          (<Stats
            setupNotCompleted={setupNotCompleted}
            onSearchEvents={this.handleSearchEventsByStatus}
            comingup={upcomingEvents}
            pendingApproval={pendingApproval}
            completedcurrent={completedCurrentSeason}
            pendingReport={pendingPostEventReport}
          />)
        }
        {
          showResults &&
          (<SearchResults
            formName={formName}
            searchResults={searchResults}
            onViewEventDetails={this.handleViewEventDetails}
            onNext={this.handleNextStep}
            onPrevious={this.handlePreviousStep}
            onGoToStep={this.handleGoToStep}
            deleteEvent={this.handleDeleteEvent}
            isAdministrator={isAdministrator}
          />)
        }
        {
          showWizard && !isEmpty(wizardsteps) &&
          (<Wizard steps={wizardsteps}
            component={component}
            saveComponentState={saveComponentState}
            resetSaveComponentState={this.handleResetSaveComponentState}
            onNext={this.handleNextStep}
            onPrevious={this.handlePreviousStep}
            onGoTo={this.handleGoToStep}
            onComponentStateSaved={this.handleOnComponentStateSaved}
            onUnmount={this.clearWizardMode}
          />)
        }
      </ContentWrapper>
    )
  }
}
Event.propTypes = {
  dispatch: PropTypes.func,
  fetchActiveSeasons: PropTypes.func,
  setDefaultEventSeason: PropTypes.func,
  deleteEvent: PropTypes.func,
  copyEvent: PropTypes.func,
  fetchEvent: PropTypes.func,
  setUserRole: PropTypes.func,
  refreshSearchResults: PropTypes.bool,
  copiedEventId: PropTypes.number,
  oidc: PropTypes.object,
  user: PropTypes.object,
  resetEventWizard: PropTypes.func,
  resetEventState: PropTypes.func,
  fetchingEvent: PropTypes.bool,
  eventRetrieved: PropTypes.bool,
  eventId: PropTypes.number,
  currentWizardStep: PropTypes.number,
  lastStepCompleted: PropTypes.number,
  location: PropTypes.object,
  history: PropTypes.object,
  searchResults: PropTypes.array,
  seasonId: PropTypes.number
}
function mapStateToProps(state, ownProps) {
  const formName = ownProps.form;
  const selector = formValueSelector(formName);
  const refreshSearchResults = selector(state, 'refreshSearchResults');
  const copiedEventId = selector(state, 'copiedEventId');
  const eventId = selector(state, 'eventId');
  const eventRetrieved = selector(state, 'eventRetrieved');
  const currentWizardStep = selector(state, 'currentWizardStep');
  const lastStepCompleted = selector(state, 'lastStepCompleted');
  const fetchingEvent = selector(state, 'fetchingEvent');
  const searchResults = selector(state, 'searchResults');
  const seasonId = selector(state, 'seasonId');
  return {
    refreshSearchResults,
    copiedEventId,
    oidc: { ...state.oidc },
    user: { ...state.user },
    eventId,
    eventRetrieved,
    currentWizardStep,
    lastStepCompleted,
    fetchingEvent,
    resetEventState,
    searchResults,
    seasonId
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchActiveSeasons,
    setDefaultEventSeason,
    deleteEvent,
    copyEvent,
    setUserRole,
    resetEventWizard,
    resetEventState,
    fetchEvent,
    fetchingEvents,
    fetchEvents
  }, dispatch)
}
export default reduxForm({
  form: formName,
  initialValues: eventdefaults,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(Event))




// WEBPACK FOOTER //
// ./src/containers/event/index.js